export default __webpack_public_path__ + "static/media/ifitToken.4b2500aa.png";